import { Fragment, useEffect } from 'react';

import { DocumentationLayout } from '@shared/compositions/documentation/layout';
import { Document, useDocument } from '@shared/docs/document';
import { toDocumentUrl } from '@shared/docs/paths';
import type { RouteComponentProps, RouteElement } from '@shared/router';
import RouteNotFound from '@shared/views/bootstrap/RouteNotFound';

import { DocsNavigation } from '@portal/views/_shared/docs-navigation';
import { PortalNavigation } from '@portal/views/_shared/navigation';

/**
 *	URL root per route, keyed by the route's `name` in ../../config/routes. The
 *	portal serves its guides and its generated reference as two documentation
 *	collections off one component. See @shared/bun/docs for the other half.
 */
const documentRoots: Record<string, string> = {
	docs: '/docs',
	reference: '/reference',
};

export default function DocumentationPage({
	name,
	params,
}: RouteComponentProps): RouteElement {
	const root = documentRoots[name ?? ''];

	const url = toDocumentUrl(root ?? '', params?.['pagePath']);
	const page = useDocument(url);

	useEffect(() => {
		if (page) {
			document.title = page.title;
		}
	}, [page]);

	if (!root || !page) {
		return <RouteNotFound />;
	}

	return (
		<Fragment>
			<PortalNavigation variant="sticky" />
			<DocumentationLayout renderSidebarWith={<DocsNavigation root={root} />}>
				<Document page={url} />
			</DocumentationLayout>
		</Fragment>
	);
}
